import type { ICurrentLanguageSelectProps } from "../../types";
import { Translate } from "@mui/icons-material";
import { FormControl, Select, InputAdornment, MenuItem } from "@mui/material";

export default function CurrentLanguageSelect(props: ICurrentLanguageSelectProps) {
  const { languages, language, styles, handleLanguageChange } = props;

  return (
    <FormControl variant="outlined" sx={{ ...styles.root }}>
      <Select
        value={language}
        onChange={handleLanguageChange}
        startAdornment={
          <InputAdornment position="start">
            <Translate />
          </InputAdornment>
        }
      >
        {languages.map((_language, i) => (
          <MenuItem key={i} value={_language.language} disabled={_language.language === language}>
            {_language.display}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
